<template>
  <div :class="classes">
    <ul class="tg-list-card-body">
      <li :class="{ selected: agent_name == selected }" :style="styleObj" @click="handleUserClick(agent_name)">
        <span>{{ title }}</span>
      </li>
      <template v-for="(row, i) in data">
        <li
          :key="i"
          :class="{ selected: row['username'] == selected }"
          :style="styleObj"
          @click="handleUserClick(row['username'])"
          disabled
        >
          <tg-user-full-name :row="row" :column="{ name: 'username', nickname: 'usernickname' }"></tg-user-full-name>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import TgUserFullName from "@/components/slot/TgUserFullName";
export default {
  components: {
    TgUserFullName,
  },
  computed: {
    classes() {
      let defClass = "tg-list-card";

      return [defClass];
    },
    styleObj() {
      if(this.disabled){
        return { 
          "color":"#cfd6e0",
          "pointer-events": "none",
        };
      }else{
        return { };
      }
    },
  },
  data() {
    return { selected: this.agent_name };
  },
  props: {
    disabled: Boolean,
    title: String,
    agent_name: String,
    data: [Array],
  },
  created() {
    // console.log("TgListCard  = "+ this.disabled);
  },
  methods: {
    handleUserClick(username) {
      this.selected = username;
      this.$emit("on-click", username);
    },
  },
  watch: {
    agent_name(val) {
      this.selected = val;
    },
  },
};
</script>
